var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7056",
    "data-name": "Path 7056",
    className: "cls-1",
    d: "M51.3,33.82V29.93A3.89,3.89,0,0,0,47.41,26V22.16a3.89,3.89,0,0,0-3.88-3.89H24.1a5.83,5.83,0,0,0-5.83,5.83h0V47.41a5.83,5.83,0,0,0,5.83,5.83H47.41a3.89,3.89,0,0,0,3.89-3.88v-3.9a1.94,1.94,0,0,0,1.94-1.94h0V35.76a1.94,1.94,0,0,0-1.94-1.94Zm-7.77,7.77a1.95,1.95,0,0,1,0-3.89h5.83v3.89ZM24.1,22.16H43.53V26H24.1a1.94,1.94,0,0,1,0-3.88ZM47.41,49.35H24.1a1.94,1.94,0,0,1-1.94-2h0V29.6a5.82,5.82,0,0,0,1.94.33H47.41v3.89H43.53a5.83,5.83,0,1,0,0,11.65h3.88Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClub);
export default __webpack_public_path__ + "static/media/club.7abb30b7461e0619cfce0bdc2ea21f01.svg";
export { ForwardRef as ReactComponent };